import { Button, Tooltip, useToast } from "@knowtex-ai/components";
import { Download } from "iconoir-react";
import { useFetchMcArtifactUrl } from "../../hooks/useMcRuns";

export const fileName = (key: string) => key.split("/").pop() || key;

/** Opens an artifact's presigned link in a new tab (the browser downloads anything it can't show). */
export function useOpenArtifact(runId: string) {
  const toast = useToast();
  const fetchUrl = useFetchMcArtifactUrl(runId);
  return async (key: string) => {
    const win = window.open("about:blank", "_blank");
    try {
      const url = await fetchUrl(key);
      if (win) win.location.href = url;
      else window.location.href = url;
    } catch (error) {
      win?.close();
      toast.error(`Couldn't open ${fileName(key)}`, (error as Error).message);
    }
  };
}

export default function ArtifactDownloadButton({ runId, artifactKey }: { runId: string; artifactKey: string }) {
  const openArtifact = useOpenArtifact(runId);
  const label = `Download ${fileName(artifactKey)}`;
  return (
    <Tooltip label={label}>
      <Button variant="secondary" size="small" icon={Download} aria-label={label} onClick={() => openArtifact(artifactKey)} />
    </Tooltip>
  );
}
